import { IOpData } from "../util/interfaces";
import { Enums } from '../common/enums'
import { OpDataType } from '../core/op-data-type'

export class OpDeviceConnectionData
    implements IOpData
{
    // region Properties

    public idDeviceConnectionData: number
    public idDeviceConnection: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // endregion

    // region NavigationProperties

    public dataType: OpDataType

    // endregion

    // region Ctor

    constructor(opObj: any) {

    }

    // endregion

    // region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // endregion

    public toJSON(compressed: boolean): any {
        return {
            ID_DEVICE_CONNECTION_DATA: this.idDeviceConnectionData,
            ID_DEVICE_CONNECTION: this.idDeviceConnection,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    public fromJSON(opObj: any, compressed: boolean): any {
        if (opObj) {
            this.idDeviceConnectionData = opObj.ID_DEVICE_CONNECTION_DATA
            this.idDeviceConnection = opObj.ID_DEVICE_CONNECTION
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            this.dataType = opObj._DataType
        }
    }

    // region IOpData Implementation

    public get idData() { return this.idDeviceConnectionData }
    public set idData(idData: number) { this.idDeviceConnectionData = idData }
    
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }
    
    // endregion

    public static fromIOpData(data: IOpData): OpDeviceConnectionData {
        let deviceConnectionData: OpDeviceConnectionData = null

        if (data) {
            deviceConnectionData = new OpDeviceConnectionData(null)

            deviceConnectionData.idDeviceConnectionData = data.idData
            deviceConnectionData.idDataType = data.idDataType
            deviceConnectionData.indexNbr = data.indexNBR
            deviceConnectionData.value = data.value
            deviceConnectionData.opState = data.opState
        }

        return deviceConnectionData
    }
}